import { createFileRoute } from '@tanstack/react-router';

import MerchantPage from '@/components/store/merchants/specific/Page';

export const Route = createFileRoute('/store/merchants/$id')({
	component: MerchantPage,
});
